import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

// const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

export const fetchGsts = createAsyncThunk(
  "gst/fetchGsts",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

 if (filters && filters.length > 0) {
  filters.forEach(
    ({
      filterField,
      filterValue,
    }: {
      filterField: string;
      filterValue: any;
    }) => {
      if (!filterField || filterValue === undefined || filterValue === null) return;

      // If filterValue is an object (like from_date/to_date)
      if (typeof filterValue === "object" && filterValue !== null) {
        if (filterValue.from_date)
          params.append(`${filterField}_date_from`, filterValue.from_date);
        if (filterValue.to_date)
          params.append(`${filterField}_date_to`, filterValue.to_date);
      } else {
        // Primitive value
        params.append(filterField, String(filterValue));
      }
    }
  );
}


    const response: any = await Axios.get(`api/gst/?${params.toString()}`);

    return {
      data: response.data.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const fetchGstById = createAsyncThunk(
  "gst/fetchGstById",
  async (gst_id: string, { getState, rejectWithValue }) => {
    try {
      const state: any = getState();
      const gstList = state.gst.gstList || [];

      const gstItem = gstList.find((item: any) => item.gst_id === gst_id);
      if (!gstItem) throw new Error("GST not found in list");

      return gstItem;
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to fetch GST");
    }
  }
);




export const fetchGstByDropDown = createAsyncThunk(
  "Gst/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`api/gst/gst-dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Gst list");
    }
  }
);

export const updateGst = createAsyncThunk(
  "gst/updateGst",
  async (data: any, { rejectWithValue }) => {
    try {
      console.log("updateGst payload:", data);
      const response = await Axios.put(
        `api/gst/edit/${data.id}/`,   
        data
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update GST");
    }
  }
);






export const updateStatusInGst = createAsyncThunk(
  "gst/updateStatusInGst",
  async (data: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: data.is_active };
      const response: any = await Axios.patch(
        `/gst/${data.id}/update/`,
        payload
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in GST"
      );
    }
  }
);

export const addGst = createAsyncThunk(
  "gst/addGst",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(`api/gst/create/`, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add GST");
    }
  }
);

export const deleteGst = createAsyncThunk(
  "gst/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await axios.delete(`/api/gst/${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// export const exportGstCSV = async () => {
//   const response = await Axios.get("/gst/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "Gst.csv",
//   };
// };

export const exportGstCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`api/gst/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "gst.csv",
  };
};
